// Format an ISO date string ("YYYY-MM-DD") as "Mon D, YYYY" in en-US locale.
// Appends `T00:00:00` so the parsed Date stays at midnight local time —
// without this, negative-UTC timezones can roll the date back one day.
// Returns '' for nullish/blank input.
export default function formatLongDate(iso) {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}
